import { SVG } from '../SVG'

const AddAdminIcon = ({ style = {}, ...props }) => (
  <SVG width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
    <path
      d='M16 20C18.7614 20 21 17.7614 21 15C21 12.2386 18.7614 10 16 10C13.2386 10 11 12.2386 11 15C11 17.7614 13.2386 20 16 20Z'
      fill='none'
      stroke='var(--primary-color)'
      strokeWidth='2'
      strokeMiterlimit='10'
    />
    <path
      d='M7.97461 24.9258C8.727 23.4438 9.87506 22.1991 11.2915 21.3297C12.708 20.4602 14.3376 20 15.9996 20C17.6616 20 19.2912 20.4602 20.7077 21.3297C22.1242 22.1991 23.2722 23.4438 24.0246 24.9258'
      fill='none'
      stroke='var(--primary-color)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M22 7H28' stroke='var(--primary-color)' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M25 4V10' stroke='var(--primary-color)' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M27.85 14.1125C27.9511 14.7366 28.0012 15.3678 28 16C28 18.3734 27.2962 20.6935 25.9776 22.6669C24.6591 24.6403 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2325 13.6589 27.7694C11.3312 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76756 16.0133 4.0052 13.6005 4.91345 11.4078C5.8217 9.21511 7.35977 7.34096 9.33316 6.02239C11.3066 4.70381 13.6266 4.00002 16 4.00002C16.6322 3.99878 17.2634 4.04895 17.8875 4.15002'
      fill='none'
      stroke='var(--primary-color)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SVG>
)

export default AddAdminIcon
